/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} My_Payments_Order_RefundedInputs */

const en_my_payments_order_refunded = /** @type {(inputs: My_Payments_Order_RefundedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Refunded`)
};

const pl_my_payments_order_refunded = /** @type {(inputs: My_Payments_Order_RefundedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zwrócone`)
};

/**
* | output |
* | --- |
* | "Refunded" |
*
* @param {My_Payments_Order_RefundedInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const my_payments_order_refunded = /** @type {((inputs?: My_Payments_Order_RefundedInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<My_Payments_Order_RefundedInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_my_payments_order_refunded(inputs)
	return en_my_payments_order_refunded(inputs)
});